import React from 'react';

import { Link } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

import {
	StyledProgramInfoBookImage,
	StyledProgramInfoBookTextBlock,
	StyledProgramInfoBookWrap,
} from './styled';

interface PropsType {
	cover: string | null;
	name: string;
	href: string;
}

function ProgramInfoBook({ cover, name, href }: PropsType) {
	return (
		<Link href={href} target="_blank" sx={{ width: '100%' }}>
			<StyledProgramInfoBookWrap elevation={2}>
				<StyledProgramInfoBookImage alt="book cover" src={cover} />
				<StyledProgramInfoBookTextBlock>
					<MediaTypography variant="body3" lineClamp={{ default: 3 }} component="p">
						{name}
					</MediaTypography>
				</StyledProgramInfoBookTextBlock>
			</StyledProgramInfoBookWrap>
		</Link>
	);
}

export default ProgramInfoBook;
